// Кратък идентификатор на стая - лесен за споделяне на глас или на ръка
// (напр. по телефон или на дъска), не само чрез копиране на линк.
//
// Съзнателен компромис: по-кратък низ означава по-голям риск от случайно
// съвпадение с чужда стая (няма централен регистър, който да провери за
// заетост преди създаване). При азбука от 32 знака и 5 знака дължина има
// 32^5 ≈ 33.5 милиона комбинации - при няколкостотин едновременно създадени
// стаи вероятността от съвпадение остава под 1%, но не е нула. Ако ОбР
// започне да създава стаи в по-голям мащаб, дължината трябва да се увеличи.
const ALPHABET = "23456789abcdefghjkmnpqrstuvwxyz"; // без 0/1/l/i/o - лесно разграничими на глас/на ръка

export function generateRoomId(length = 5): string {
  let out = "";
  for (let i = 0; i < length; i++) {
    out += ALPHABET[Math.floor(Math.random() * ALPHABET.length)];
  }
  return out;
}
